// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2525":"5fc0a8e1274e696c","4786":"beb76beb7ecda251","5700":"66d40326ef3a5320","7778":"beb76beb7ecda251"}[chunkId] + ".css";
};